import { Column } from './types'

import styles from './useHeaderColumnProps.scss'


export const headerProps = {
  [Column.Date]: { alignLeft: true, className: styles.columnTitle },
  [Column.Value]: { alignRight: true, className: styles.columnTitle },
  [Column.OperationType]: { alignRight: true },
  [Column.Comment]: { alignRight: true },
}

export function useHeaderColumnProps() {
  return headerProps
}
